<script>
    let { children } = $props();
</script>

<header class="m-0 block p-0">
    {@render children?.()}
</header>
